// extracted by mini-css-extract-plugin
export default {"bid-list-action-bar":"style_bid-list-action-bar__jqCeV","bidListActionBar":"style_bid-list-action-bar__jqCeV"};